// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-EligibilityCriteria-components-HighlightsModal-HighlightsPanel-module__apiErrorMessage";
var _2 = "webpack-pages-EligibilityCriteria-components-HighlightsModal-HighlightsPanel-module__keywordSectionDivider";
var _3 = "webpack-pages-EligibilityCriteria-components-HighlightsModal-HighlightsPanel-module__loadingSpinner";
var _4 = "webpack-pages-EligibilityCriteria-components-HighlightsModal-HighlightsPanel-module__showOptions";
export { _1 as "apiErrorMessage", _2 as "keywordSectionDivider", _3 as "loadingSpinner", _4 as "showOptions" }
